import React, { useEffect, useState } from "react";
import api from "../../../api/api";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import PostForm from "./PostForm";

const AdminEditPost = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadPost = async () => {
    try {
      const res = await api.get("/posts?limit=100");
      const found = res.data.items.find((p) => p.id === id);

      if (!found) {
        toast.error("Post not found");
        navigate("/admin/posts");
        return;
      }

      setPost(found);
    } catch (err) {
      toast.error(err.cleanMessage);
    }
  };

  const updatePost = async (data) => {
    setLoading(true);

    try {
      await api.put(`/posts/${id}`, data);
      toast.success("Post updated successfully");
      navigate("/admin/posts");
    } catch (err) {
      toast.error(err.cleanMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPost();
  }, [id]);

  if (!post) return <p>Loading post...</p>;

  return (
    <section>
      <h1 className="text-3xl font-black text-[#0b6b1d] mb-6">
        Edit Post
      </h1>

      <PostForm initialData={post} onSubmit={updatePost} loading={loading} />
    </section>
  );
};

export default AdminEditPost;